import axios from './index'
const { VUE_APP_AUTH } = process.env

export default {
  employeeLogin(data) {
    return axios.post(`${VUE_APP_AUTH}/api/v1/auth/login/employee`, data)
  },
}